// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackSearchSortedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackSearchSorted";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackSearchSorted = (
    parameters: PartialSpecific<TrackSearchSortedParameters, "sort_type"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    const hookParameters = {
        ...ga.use.eventParameters(options),
        ...parameters,
    } as TrackSearchSortedParameters;

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        skipOptionItems: true,
        ...options,
    };

    return (parameters: TrackSearchSortedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.searchSorted({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackSearchSorted;
